import Vue from 'vue'
import VueRouter from 'vue-router'
import Daftar from '../views/Daftar.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue')
  },
  {
    path: '/daftar',
    name: 'daftar',
    component: Daftar
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue')
  },
  
  {
    path: '/pembayaran',
    name: 'pembayaran',
    component: () => import(/* webpackChunkName: "pembayaran" */ '../views/UploadBuktiBayar.vue')
  },
  {
    path: '/profil',
    name: 'profil',
    component: () => import(/* webpackChunkName: "profil" */ '../views/Profil.vue')
  },
  {
    path: '/tagihan',
    name: 'tagihan',
    component: () => import(/* webpackChunkName: "tagihan" */ '../views/Tagihan.vue')
  },
  {
    path: '/upload-berkas',
    name: 'upload',
    component: () => import(/* webpackChunkName: "upload" */ '../views/Upload.vue')
  },
  {
    path: '/ujian',
    name: 'ujian',
    component: () => import(/* webpackChunkName: "ujian" */ '../views/Ujian.vue')
  },
  {
    path: '/pengumuman',
    name: 'pengumuman',
    component: () => import(/* webpackChunkName: "pengumuman" */ '../views/Pengumuman.vue')
  },
  {
    path: '/kelas-internasional',
    name: 'kelas-internasional',
    component: () => import(/* webpackChunkName: "kelas-internasional" */ '../views/KelasInternasional.vue')
  }
]

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes
})

export default router
